import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AccountMoveLightModel } from '../../../store/accounting/types';
import { ModalContentComponent } from '../../modal-content/modal-content.component';
import { ActionButton } from '../../modal-content/action-button';
import { SourceEnum } from '../../../store/typeahead/types';
import { ModalService } from '../../../service/modal.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponentKey } from 'src/app/shared/service/modal-component';

@Component({
  selector: 'app-account-move-issuing-details',
  standalone: false,
  templateUrl: './account-move-issuing-details.component.html',
  styleUrl: './account-move-issuing-details.component.scss',
})
export class AccountMoveIssuingDetailsComponent
  implements ICellRendererAngularComp
{
  paymentId: number;
  readonly invoices = signal<AccountMoveLightModel[]>([]);

  constructor(
    private readonly modalService: NgbModal,
    private readonly modalExchangeService: ModalService,
  ) {}

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }
  refresh(params: ICellRendererParams): boolean {
    this.invoices.set(params.value);
    this.paymentId = params.data['accountMoveId'];
    return true;
  }

  openModalBindAccountMovesDetails(event: Event) {
    const modalRef = this.modalService.open(ModalContentComponent, {
      size: 'xl',
      backdrop: true,
    });

    modalRef.componentInstance.component =
      this.modalExchangeService.getComponentClass(
        ModalComponentKey.AccountMoveAssignDetails,
      );
    modalRef.componentInstance.title = 'ACCOUNTMOVE_LBL_PAYMENTS_INVOICES';

    modalRef.componentInstance.closeCrossButton = true;
    modalRef.componentInstance.cancelButton = false;
    let buttons: ActionButton[] = [];

    modalRef.componentInstance.buttons = buttons;
    modalRef.componentInstance.inputParams = {
      source: SourceEnum.Modal,
      accountMoveId: this.paymentId,
      bindType: 'Payment',
      linkTo: true,
    };

    modalRef.result
      .then((id) => {
        if (id >= 0) {
          // do nothing
        }
      })
      .finally(() => {
        //avoid error on cancel
      });
  }
}
